export default __webpack_public_path__ + "static/gaku-screen-1-f34f2a561542de3ffeec67d5499341cc.png";